<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path
      fill="currentColor"
      d="M19 38l19 -19h225l18 19v225l-18 18h-225l-19 -18v-225zM38 38v225h225v-225h-225zM56 56h38v19h-38v-19zM113 56h37v19h-37v-19zM206 56h-37v19h37v-19z"
    />
  </svg>
</template>
